import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  Admin_Parivartan_Delete_Branch,
  Admin_Parivartan_Pincode_delete,
  Admin_Parivartan_Update_Pincode,
} from "../../../../constants";
import axios from "axios";

const PincodeTableComponent = ({
  pincodeList,
  loading,
  setLoading,
  onRefresh,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Slice data for current page
  const paginatedRows = pincodeList.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [pincode, setPincode] = useState("");
  const [selectedPincode, setSelectedPincode] = useState("");

  const handleDeleteCategory = async () => {
    if (!selectedPincode) return;

    try {
      setLoading(true);
      const response = await axios.delete(
        `${Admin_Parivartan_Pincode_delete}/${selectedPincode}`
      );

      if (response.data.success === true) {
        console.log("Pincode deleted successfully");
        setDeleteModalOpen(false);
        onRefresh();
      } else {
        console.error("Failed to delete pincode");
      }
    } catch (error) {
      console.error("Error deleting pincode:", error);
    } finally {
      setLoading(false);
    }
  };

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editForm, setEditForm] = useState({
    PlaceName: "",
    NewPincode: "",
  });

  const handleEditCategory = async () => {
    if (!pincode) return;

    try {
      setLoading(true);
      const response = await axios.put(
        `${Admin_Parivartan_Update_Pincode}/${pincode}`,
        editForm
      );
      console.log(response.data);
      if (response.data.success) {
        console.log("Pincode updated successfully");
        setEditModalOpen(false);
        onRefresh();
      } else {
        console.error("Failed to update pincode");
      }
    } catch (error) {
      console.error("Error updating pincode:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      // <div>Loading region assignments...</div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight={120}
      >
        <CircularProgress size={24} sx={{ mr: 2 }} />
        <Typography>Loading Pincode List...</Typography>
      </Box>
    );
  }

  if (!pincodeList || pincodeList.length === 0) {
    return (
      // <div>No region assignments found.</div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight={120}
      >
        <Typography>No Pincode found.</Typography>
      </Box>
    );
  }

  return (
    <>
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Box p={0}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "grey.100" }}>
                  <TableCell sx={{ fontWeight: 600 }}>S No.</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Place Id</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Pincode</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>City Name</TableCell>
                  <TableCell sx={{ fontWeight: 600 }} width={50}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pincodeList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 6 }}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        gap={1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={48}
                          height={48}
                          fill="none"
                          viewBox="0 0 24 24"
                          style={{ color: "#bdbdbd", marginBottom: 8 }}
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                        <Typography color="text.secondary">
                          No RO/BO found
                        </Typography>
                        <Typography variant="body2" color="text.disabled">
                          Try adjusting your search or filters
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedRows.map((ro, index) => (
                    <TableRow key={ro.id}>
                      <TableCell>
                        <Typography variant="body2">{index + 1}.</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {ro.PlaceId || "-"}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2" fontWeight="500">
                          {ro.PlaceName || "-"}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2" fontWeight="500">
                          {ro.PINCode || "-"}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2">
                          {ro.CityName || "-"}
                        </Typography>
                      </TableCell>

                      <TableCell width={120}>
                        {/* Update Button */}
                        <Button
                          size="small"
                          variant="outlined"
                          color="secondary"
                          onClick={(e) => {
                            e.stopPropagation();
                            setPincode(ro.PlaceId);
                            setSelectedPincode(ro.PINCode);
                            setEditForm({
                              PlaceName: ro.PlaceName,
                              NewPincode: ro.PINCode,
                            }); // pre-fill form
                            setEditModalOpen(true); // open edit modal
                          }}
                          sx={{ mr: 1 }}
                        >
                          Update
                        </Button>

                        {/* Delete Button */}
                        <Button
                          size="small"
                          variant="outlined"
                          color="warning"
                          onClick={(e) => {
                            e.stopPropagation();
                            setPincode(ro.PlaceId);
                            setSelectedPincode(ro.PlaceId);
                            setDeleteModalOpen(true); // open delete modal
                          }}
                          sx={{mt: 1}}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* Pagination */}
          {pincodeList.length > 0 && (
            <TablePagination
              component="div"
              count={pincodeList.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          )}
        </Box>
      </Paper>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Delete Pincode</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the pincode{" "}
            <Box component="span" fontWeight="bold" display="inline">
              {pincode}
            </Box>
            ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteModalOpen(false)}
            disabled={loading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteCategory}
            color="error"
            disabled={loading}
            variant="contained"
          >
            {loading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Pincode Modal */}
      <Dialog
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Edit Pincode</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {/* Place Name */}
            <Grid item xs={12}>
              <TextField
                label="Place Name"
                value={editForm.PlaceName || ""}
                onChange={(e) =>
                  setEditForm((prev) => ({
                    ...prev,
                    PlaceName: e.target.value,
                  }))
                }
                fullWidth
                size="small"
              />
            </Grid>

            {/* Pincode */}
            <Grid item xs={12}>
              <TextField
                label="Pincode"
                value={editForm.NewPincode || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only numbers, max 6 digits
                  if (/^\d{0,6}$/.test(value)) {
                    setEditForm((prev) => ({ ...prev, NewPincode: value }));
                  }
                }}
                fullWidth
                size="small"
                inputProps={{ maxLength: 6 }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setEditModalOpen(false)}
            disabled={loading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleEditCategory}
            disabled={loading}
            variant="contained"
          >
            {loading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Saving...
              </>
            ) : (
              "Save"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PincodeTableComponent;
